import React from "react";
import { IconProps } from "../../utils/global-types/global-types";

const ArrowRightIcon = ({ className, ...rest }: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 13 12"
      className={className ? className : "w-[13px] h-[12px]"}
      {...rest}
    >
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        // strokeWidth="1.219"
        d="M4.627 2.564h4.905V7.47M2.663 9.435l6.8-6.8"
      ></path>
    </svg>
  );
};

export default ArrowRightIcon;
